import { createSelector } from "@reduxjs/toolkit";
import { Task } from "../../entities/task";
import { mapToArray } from "../../helpers";
import { AppState } from "../appState";

const selectTasks = (state: AppState) => state.kronosState.taskState.tasks;
const selectTaskSearchMetadata = (state: AppState) =>
  state.kronosState.taskState.searchMetadata;
const selectTaskFilters = (state: AppState) =>
  state.kronosState.taskState.filters;
const selectTaskSearchOpen = (state: AppState) =>
  state.kronosState.taskState.searchOpen;
const selectSelectedTaskID = (state: AppState) =>
  state.kronosState.taskState.selectedTaskID;
const selectStageTaskSelector = (state: AppState) =>
  state.kronosState.taskState.stagedTask;
const selectTaskLoading = (state: AppState) =>
  state.kronosState.taskState.loading;
const selectTaskFormOpen = (state: AppState) =>
  state.kronosState.taskState.taskFormOpen;

export const taskFormOpenSelector = createSelector(
  [selectTaskFormOpen],
  (s) => s
);

export const taskLoadingSelector = createSelector(
  [selectTaskLoading],
  (s) => s
);

export const tasksSelector = createSelector([selectTasks], (tasks) =>
  mapToArray(tasks)
);

export const selectedTaskSelector = createSelector(
  [selectTasks, selectSelectedTaskID],
  (tasks, selectedTaskID) => {
    if (selectedTaskID) return tasks[selectedTaskID];
    return undefined;
  }
);

export const stagedTaskSelector = createSelector(
  [selectStageTaskSelector],
  (s) => (s ? new Task(s) : s)
);

export const selectedTaskIDSelector = createSelector(
  [selectSelectedTaskID],
  (s) => s
);

export const taskSearchOpenSelector = createSelector(
  [selectTaskSearchOpen],
  (s) => s
);

export const taskSearchMetadataSelector = createSelector(
  [selectTaskSearchMetadata],
  (s) => s
);

export const taskFiltersSelector = createSelector(
  [selectTaskFilters],
  (s) => s
);

export const taskSelector = (id?: number) => {
  return createSelector([selectTasks], (tasks) => {
    if (id) return tasks[id];
    return undefined;
  });
};
